import type { MessageAppearanceRow, TimeRange } from './types'

const minCreated = (rows: MessageAppearanceRow[]) => {
  if (rows.length === 0) return null
  let min = rows[0].created
  for (let i = 1; i < rows.length; i += 1) {
    if (rows[i].created < min) min = rows[i].created
  }
  return min
}

const maxCreated = (rows: MessageAppearanceRow[]) => {
  if (rows.length === 0) return null
  let max = rows[0].created
  for (let i = 1; i < rows.length; i += 1) {
    if (rows[i].created > max) max = rows[i].created
  }
  return max
}

export const getBatchTargetRange = (
  parents: MessageAppearanceRow[],
  matchWindowMs: number,
  bufferMs: number
): TimeRange | null => {
  const batchMin = minCreated(parents)
  const batchMax = maxCreated(parents)
  if (batchMin == null || batchMax == null) return null

  return {
    min: batchMin - bufferMs,
    max: batchMax + matchWindowMs + bufferMs
  }
}
